import { render, staticRenderFns } from "./account_statements.vue?vue&type=template&id=0e05b7ac&scoped=true"
import script from "./account_statements.vue?vue&type=script&lang=js"
export * from "./account_statements.vue?vue&type=script&lang=js"
import style0 from "./account_statements.vue?vue&type=style&index=0&id=0e05b7ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e05b7ac",
  null
  
)

export default component.exports